import * as Yup from 'yup';
import {
	VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES,
	MTA_ADDRESS_CHANGE_ERRORS,
} from '@acorn-portal/shared/src/utils/constants/ErrorMessages';
import { MAX_VEHICLE_VALUE } from '@acorn-portal/shared/src/utils/constants';
import { isAfter } from 'date-fns';
import { isNotInFutureMonth } from '@acorn-portal/shared/src/utils';

export const amendVehiclePart2Schema = (manufactureYear: number) =>
	Yup.object().shape({
		owner: Yup.string().required(VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES.owner),
		registeredKeeper: Yup.string().required(VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES.keeper),
		hasModifications: Yup.string().required(VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES.hasModifications),
		imported: Yup.string().required(VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES.imported),
		isLeftHandDrive: Yup.string().required(VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES.leftHandDrive),
		purchasedDate: Yup.object()
			.shape({
				month: Yup.string().required(VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES.purchaseDate),
				year: Yup.string().required(VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES.purchaseDate),
			})
			.test('is-after-manufacture', function (value) {
				const month = value?.month;
				const year = value?.year;
				if (!month || !year || !manufactureYear) {
					return true;
				}
				if (isAfter(new Date(manufactureYear, 0, 1), new Date(parseInt(year, 10), parseInt(month, 10) - 1, 1))) {
					return this.createError({
						path: 'purchasedDate.year',
						message: `${VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES.purchaseMinDate} (${manufactureYear})`,
					});
				}
				return true;
			})
			.test('is-not-in-future', function (value) {
				const month = value?.month;
				const year = value?.year;
				if (!month || !year) {
					return true;
				}
				if (!isNotInFutureMonth(new Date(parseInt(year, 10), parseInt(month, 10) - 1, 1))) {
					return this.createError({
						path: 'purchasedDate.year',
						message: VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES.purchaseMaxDate,
					});
				}
				return true;
			}),
		keptOvernight: Yup.string().required(VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES.keptOvernight),
		overnightAddressIsAway: Yup.string().required(MTA_ADDRESS_CHANGE_ERRORS.overnightAddressIsAwayRequired),
		value: Yup.number()
			.max(MAX_VEHICLE_VALUE, VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES.valueMaxAmount)
			.required(VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES.valueRequired),
		levelOfCover: Yup.string().required(VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES.levelOfCover),
		modifications: Yup.mixed().when('hasModifications', {
			is: 'yes',
			then: () => Yup.array().min(1, VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES.modifications),
			otherwise: (schema) => schema.notRequired(),
		}),
		countryOfRegistration: Yup.mixed().when('imported', {
			is: 'yes',
			then: () => Yup.string().required(VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES.countryOfRegistration),
			otherwise: (schema) => schema.notRequired(),
		}),
	});
